import styled from '@emotion/styled'
import { Col } from 'react-bootstrap'

export const AllEstimatesDisclaimer = styled.div`
  label: AllEstimatesDisclaimer;
  text-align: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'left' : 'center'};
  margin: 12px 0px;
`

export const carTitle = styled.h3`
  label: carTitle;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '24px' : '28px')};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 800)};
  text-align: center;
  margin-bottom: 18px;
  color: #000;
`

export const carDescriptionDiv = styled.div`
  label: carDescriptionDiv;
  margin-bottom: 12px;
  text-align: center;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const indicativeImgText = styled.p`
  label: indicativeImgText;
  text-align: center;
  font-size: 14px;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const RRPrice = styled.div`
  label: RRPrice;
  color: ${(props) => props.theme.colors.alertGreen};
  font-weight: 700;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '24px' : '19px')};
`

export const RRPSubText = styled.span`
  label: RRPSubText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  margin-right: 6px;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 700)};
`

export const RRSubTextPrice = styled.div`
  label: RRPSubTextPrice;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.primary
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 700)};
  text-decoration: line-through;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '18px' : '19px')};
`

export const CarPriceDiv = styled(Col)`
  label: CarPriceDiv;
  text-transform: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'uppercase' : 'none'};
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: 700;
`

export const DrivingHomeCol = styled(Col)`
  label: DrivingHomeCol;
  color: ${(props) => props.theme.colors.primary};
  text-transform: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'uppercase' : 'none'};
  font-weight: bold;
  margin-bottom: 6px;
`

export const YourGSTSaving = styled(Col)`
  label: YourGSTSaving;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: bold;
  margin-top: ${(props) => (props.theme.brand === 'Maxxia' ? '6px' : '42px')};
`
